import {
  createFunction as publicCreateFunction,
  getFunction as publicGetFunction,
  updateFunction as publicUpdateFunction,
  deleteFunction as publicDeleteFunction,
  queryFunctions as publicQueryFunctions,
  typedQueryFunctions as publicTypedQueryFunctions,
  bulkUpdateFunctionTags as publicBulkUpdateFunctionTags,
  bulkUpdateFunctionTagsByFilter as publicBulkUpdateFunctionTagsByFilter,
} from './functions-v1-function-functions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  FunctionsQueryBuilder,
  _FunctionQuery,
  typedQueryFunctions as universalTypedQueryFunctions,
} from './functions-v1-function-functions.universal.js';
import { onFunctionCreated as publicOnFunctionCreated } from './functions-v1-function-functions.public.js';
import { onFunctionDeleted as publicOnFunctionDeleted } from './functions-v1-function-functions.public.js';
import { onFunctionTagsModified as publicOnFunctionTagsModified } from './functions-v1-function-functions.public.js';
import { onFunctionUpdated as publicOnFunctionUpdated } from './functions-v1-function-functions.public.js';

function customQueryFunctions(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryFunctions(httpClient)(),
    typedQueryFunction: (query: _FunctionQuery) =>
      publicTypedQueryFunctions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): FunctionsQueryBuilder;
  function overloadedQuery(
    query: _FunctionQuery
  ): ReturnType<typeof universalTypedQueryFunctions>;
  function overloadedQuery(query?: _FunctionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createFunction: MaybeContext<
  BuildRESTFunction<typeof publicCreateFunction> & typeof publicCreateFunction
> = /*#__PURE__*/ createRESTModule(publicCreateFunction);
export const getFunction: MaybeContext<
  BuildRESTFunction<typeof publicGetFunction> & typeof publicGetFunction
> = /*#__PURE__*/ createRESTModule(publicGetFunction);
export const updateFunction: MaybeContext<
  BuildRESTFunction<typeof publicUpdateFunction> & typeof publicUpdateFunction
> = /*#__PURE__*/ createRESTModule(publicUpdateFunction);
export const deleteFunction: MaybeContext<
  BuildRESTFunction<typeof publicDeleteFunction> & typeof publicDeleteFunction
> = /*#__PURE__*/ createRESTModule(publicDeleteFunction);
export const bulkUpdateFunctionTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateFunctionTags> &
    typeof publicBulkUpdateFunctionTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateFunctionTags);
export const bulkUpdateFunctionTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateFunctionTagsByFilter> &
    typeof publicBulkUpdateFunctionTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateFunctionTagsByFilter);
export const queryFunctions: MaybeContext<
  BuildRESTFunction<typeof customQueryFunctions> & typeof customQueryFunctions
> = /*#__PURE__*/ createRESTModule(customQueryFunctions);
/**
 * Triggered when a function is created.
 */
export const onFunctionCreated: BuildEventDefinition<
  typeof publicOnFunctionCreated
> &
  typeof publicOnFunctionCreated = /*#__PURE__*/ createEventModule(
  publicOnFunctionCreated
);
/**
 * Triggered when a function is deleted.
 */
export const onFunctionDeleted: BuildEventDefinition<
  typeof publicOnFunctionDeleted
> &
  typeof publicOnFunctionDeleted = /*#__PURE__*/ createEventModule(
  publicOnFunctionDeleted
);
/**
 * Triggered when tags are modified.
 */
export const onFunctionTagsModified: BuildEventDefinition<
  typeof publicOnFunctionTagsModified
> &
  typeof publicOnFunctionTagsModified = /*#__PURE__*/ createEventModule(
  publicOnFunctionTagsModified
);
/**
 * Triggered when a function is updated.
 */
export const onFunctionUpdated: BuildEventDefinition<
  typeof publicOnFunctionUpdated
> &
  typeof publicOnFunctionUpdated = /*#__PURE__*/ createEventModule(
  publicOnFunctionUpdated
);

export {
  ActivationStatus,
  SortOrder,
  WebhookIdentityType,
} from './functions-v1-function-functions.universal.js';
export {
  _Function,
  Tags,
  TagList,
  DraftDiscarded,
  TagsModified,
  CreateFunctionRequest,
  CreateFunctionResponse,
  GetFunctionRequest,
  GetFunctionResponse,
  UpdateFunctionRequest,
  UpdateFunctionResponse,
  DeleteFunctionRequest,
  DeleteFunctionResponse,
  QueryFunctionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryFunctionsResponse,
  CursorPagingMetadata,
  Cursors,
  ListValuesByFieldRequest,
  ListValuesByFieldResponse,
  FieldAndCount,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  UpdateFunctionExternalIdsRequest,
  UpdateFunctionExternalIdsResponse,
  BulkUpdateFunctionTagsRequest,
  BulkUpdateFunctionTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateFunctionTagsResult,
  BulkActionMetadata,
  BulkUpdateFunctionTagsByFilterRequest,
  BulkUpdateFunctionTagsByFilterResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  FunctionCreatedEnvelope,
  FunctionDeletedEnvelope,
  FunctionTagsModifiedEnvelope,
  FunctionUpdatedEnvelope,
  UpdateFunction,
  FunctionsQueryResult,
  FunctionsQueryBuilder,
  _FunctionQuerySpec,
  BulkUpdateFunctionTagsOptions,
  BulkUpdateFunctionTagsByFilterOptions,
} from './functions-v1-function-functions.universal.js';
export { utils } from './functions-v1-function-functions.universal.js';
export {
  ActivationStatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateFunctionTagsApplicationErrors,
  BulkUpdateFunctionTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  _FunctionQuery,
} from './functions-v1-function-functions.universal.js';
